import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 32px;
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      height: 100%;
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    text-align: center;
    color: ${theme.v2.colors.neutral.extraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    font-family: ${theme.v2.font.family.primary};
    margin-bottom: 16px;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    font-family: ${theme.v2.font.family.primary};
    margin-bottom: 40px;
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: center;
    gap: 8px;
  `}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  align-items: center;
  width: 265px;
`;

export const RequestsLimitWrapper = styled.p`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 24px;
    margin: 40px 0 4px 0;
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    font-family: ${theme.v2.font.family.primary};
  `};
`;

export const RequestLimitTitle = styled.span`
  ${({ theme }) => css`
    display: inline-block;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    font-family: ${theme.v2.font.family.primary};
    text-align: center;
    margin-bottom: 4px;
  `};
`;

export const BackButtonWrapper = styled.div`
  max-width: 285px;
  margin-top: 24px;
`;
